import { FormLabel, Stack } from "@mui/material";
import { useDisabledInput } from "@sinch/hooks/utilities/UseDisabledInput";
import React, { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CheckboxInput } from "@sinch/components/form/CheckboxInput/CheckboxInput";

export interface MinimumHoursOptionsProps {
  onChange: (val: MinimumHoursOptionsValue) => void;
  value: MinimumHoursOptionsValue;
  disabled: boolean;
}

export interface MinimumHoursOptionsValue {
  minimum: { overrideWorkedHours: boolean /*limitWithWorkTime: boolean*/ };
}

export const MinimumHoursOptions: FC<MinimumHoursOptionsProps> = ({ onChange, value, disabled }) => {
  const { t } = useTranslation();
  return (
    <>
      <FormLabel sx={{ display: "flex", alignItems: "left" }}>{t("RateBuilder.minimumTimeSectionTitle")}</FormLabel>
      <Stack direction="row" spacing={2}>
        <OverrideTime
          disabled={disabled}
          onChange={(val) => onChange({ ...value, minimum: { ...value.minimum, overrideWorkedHours: val } })}
          value={value?.minimum.overrideWorkedHours}
        />
        {/*<LimitWithWorkTime*/}
        {/*  disabled={disabled}*/}
        {/*  onChange={(val) => onChange({ ...value, minimum: { ...value.minimum, limitWithWorkTime: val } })}*/}
        {/*  value={value?.minimum.limitWithWorkTime}*/}
        {/*/>*/}
      </Stack>
    </>
  );
};

interface LimitWithWorkTimeProps {
  onChange: (val: boolean) => void;
  value: boolean;
  disabled: boolean;
}
// TODO: CHECK IF THIS COMPONENT SHOULD BE USED
// oxlint-disable-next-line no-unused-vars
const LimitWithWorkTime: FC<LimitWithWorkTimeProps> = ({ value, onChange, disabled }) => {
  const { t } = useTranslation();

  const [isDisabled, setDisabled, changeHandler] = useDisabledInput({
    initDisabled: disabled,
    initialValue: value,
    onChange: onChange,
    emptyValue: false,
  });

  useEffect(() => {
    setDisabled(disabled);
  }, [disabled]);

  return (
    <CheckboxInput
      disabled={isDisabled}
      FormControlProps={{ fullWidth: false }}
      label={t("RateBuilder.canNotBeLongerThenActualWork")}
      onChange={(e) => changeHandler(e.target.checked)}
      value={value}
    />
  );
};

interface OverrideTimeProps {
  onChange: (val: boolean) => void;
  value: boolean;
  disabled: boolean;
}

const OverrideTime: FC<OverrideTimeProps> = ({ onChange, value, disabled }) => {
  const { t } = useTranslation();

  const [disabledInput, setDisabled, changeHandler] = useDisabledInput({
    initDisabled: disabled,
    initialValue: value,
    onChange: onChange,
    emptyValue: false,
  });

  useEffect(() => {
    setDisabled(disabled);
  }, [disabled]);

  return (
    <CheckboxInput
      data-cy="IntervalSelect-overrideTime-input"
      disabled={disabledInput}
      FormControlProps={{ fullWidth: false }}
      infoTooltip={t("RateBuilder.overrideActualWorkedTimeDescription")}
      label={t("RateBuilder.overrideActualWorkedTime")}
      onChange={(e) => changeHandler(e.target.checked)}
      value={value}
    />
  );
};
